import { useEffect } from "react";
import { htmlToPlainText } from "../../../../utility/htmlToPlainText";
import { useTheme } from "../../../../context/useThemeContext";
import useTextFilesStore from "../../../../stores/textFilesStore";

function NoteContent(props: { noteID: string }) {
    const { theme } = useTheme();
    const textFile = useTextFilesStore((state) =>
        htmlToPlainText(
            state.textFiles[props.noteID]?.content.substring(0, 300) || ""
        )
    );

    useEffect(() => {
        // Load the text file
        useTextFilesStore.getState().getTextFile(props.noteID);
    }, []);

    return (
        <p
            className="noteBody overflow-hidden text-ellipsis max-h-[54px] min-h-[40px] text-sm line-clamp-2 min-w-[200px] whitespace-break-spaces"
            style={{
                color: theme.fontColor[100],
            }}
        >
            {textFile}
        </p>
    );
}

export default NoteContent;
